import { mutator, orchestrator } from 'satcheljs';
import { initializeArchiveFolderTreeFromSessionData } from '../actions/publicActions';
import type { MailFolder } from 'owa-graph-schema';
import { ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID } from 'owa-folders-constants';
import { getUserConfiguration } from 'owa-session-store';
import getMailboxFolderTreeDataTable from '../selectors/getMailboxFolderTreeDataTable';
import { removeFolderTreeData } from '../actions/removeFolderTreeData';
import FolderTreeLoadStateEnum from '../store/schema/FolderTreeLoadStateEnum';
import { setFolderTreeData } from './setFolderTreeData';
import { getUserMailboxInfo } from 'owa-client-ids';

/**
 * Initializes the archive mailbox folder tree.
 */
orchestrator(initializeArchiveFolderTreeFromSessionData, () => {
    // Initialize the archive root folder using the data received in session data such as display name and set it in the store.
    const userIdentity = getUserMailboxInfo().userIdentity;
    const folder = <MailFolder>{
        distinguishedFolderType: ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (22,22): Object is possibly 'undefined'.
        // @ts-expect-error
        displayName: getUserConfiguration().SessionSettings.ArchiveDisplayName,
        mailboxInfo: {
            type: 'ArchiveMailbox',
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2532 (28,33): Object is possibly 'undefined'.
            // @ts-expect-error
            mailboxSmtpAddress: getUserConfiguration().SessionSettings.ArchiveMailboxGuid,
            userIdentity: userIdentity,
        },
    };

    // update the archive folder tree root and loading state.
    setFolderTreeData(
        ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID,
        folder,
        FolderTreeLoadStateEnum.Uninitialized,
        false,
        0,
        userIdentity
    );
});

mutator(removeFolderTreeData, actionMessage => {
    getMailboxFolderTreeDataTable(actionMessage.userIdentity).delete(actionMessage.folderTreeId);
});
